export const FETCH_LINKS_LIST = 'LINKS/FETCH_LINKS_LIST';
export const FETCH_LINKS_LIST_ERROR = 'LINKS/FETCH_LINKS_LIST_ERROR';
export const CLEAR_FETCH_LINKS_LIST = 'LINKS/CLEAR_FETCH_LINKS_LIST';

export const APPLY_LINK_DRAG = 'LINKS/APPLY_LINK_DRAG';
export const APPLY_LINK_DRAG_ERROR = 'LINKS/APPLY_LINK_DRAG_ERROR';
export const CLEAR_LINK_DRAG = 'LINKS/CLEAR_LINK_DRAG';

export const ADD_LINK_SUCCESS = 'LINKS/ADD_LINK_SUCCESS';
export const ADD_LINK_ERROR = 'LINKS/ADD_LINK_ERROR';
export const CLEAR_ADD_LINK = 'LINKS/CLEAR_ADD_LINK';

export const DELETE_LINK_SUCCESS = 'LINKS/DELETE_LINK_SUCCESS';
export const DELETE_LINK_ERROR = 'LINKS/DELETE_LINK_ERROR';
export const CLEAR_DELETE_LINK = 'LINKS/CLEAR_DELETE_LINK';

export const PATCH_LINK_SUCCESS = 'LINKS/PATCH_LINK_SUCCESS';
export const PATCH_LINK_ERROR = 'LINKS/PATCH_LINK_ERROR';
export const CLEAR_PATCH_LINK = 'LINKS/CLEAR_PATCH_LINK';


// SOCIAL LINKS
export const FETCH_SOCIAL_NETWORKS_LIST = 'LINKS/FETCH_SOCIAL_NETWORKS_LIST';
export const FETCH_SOCIAL_NETWORKS_LIST_ERROR = 'LINKS/FETCH_SOCIAL_NETWORKS_LIST_ERROR';
export const CLEAR_FETCH_SOCIAL_NETWORKS_LIST = 'LINKS/CLEAR_FETCH_SOCIAL_NETWORKS_LIST';

export const FETCH_SOCIAL_LINKS_LIST = 'LINKS/FETCH_SOCIAL_LINKS_LIST';
export const FETCH_SOCIAL_LINKS_LIST_ERROR = 'LINKS/FETCH_SOCIAL_LINKS_LIST_ERROR';
export const CLEAR_FETCH_SOCIAL_LINKS_LIST = 'LINKS/CLEAR_FETCH_SOCIAL_LINKS_LIST';

export const ADD_SOCIAL_LINK_SUCCESS = 'LINKS/ADD_SOCIAL_LINK_SUCCESS';
export const ADD_SOCIAL_LINK_ERROR = 'LINKS/ADD_SOCIAL_LINK_ERROR';
export const CLEAR_ADD_SOCIAL_LINK = 'LINKS/CLEAR_ADD_SOCIAL_LINK';

export const DELETE_SOCIAL_LINK_SUCCESS = 'LINKS/DELETE_SOCIAL_LINK_SUCCESS';
export const DELETE_SOCIAL_LINK_ERROR = 'LINKS/DELETE_SOCIAL_LINK_ERROR';
export const CLEAR_DELETE_SOCIAL_LINK = 'LINKS/CLEAR_DELETE_SOCIAL_LINK';

export const PATCH_SOCIAL_LINK_SUCCESS = 'LINKS/PATCH_SOCIAL_LINK_SUCCESS';
export const PATCH_SOCIAL_LINK_ERROR = 'LINKS/PATCH_SOCIAL_LINK_ERROR';
export const CLEAR_PATCH_SOCIAL_LINK = 'LINKS/CLEAR_PATCH_SOCIAL_LINK';

export const SET_SOCIAL_LINKS_BUTTONS_MODE_SUCCESS = 'LINKS/SET_SOCIAL_LINKS_BUTTONS_MODE_SUCCESS';
export const SET_SOCIAL_LINKS_BUTTONS_MODE_ERROR = 'LINKS/SET_SOCIAL_LINKS_BUTTONS_MODE_ERROR';
export const CLEAR_SET_SOCIAL_LINKS_BUTTONS_MODE = 'LINKS/CLEAR_SET_SOCIAL_LINKS_BUTTONS_MODE';

export const REQUEST_SOCIAL_LINK_STATUS_SUCCESS = 'LINKS/REQUEST_SOCIAL_LINK_STATUS_SUCCESS';
export const REQUEST_SOCIAL_LINK_STATUS_ERROR = 'LINKS/REQUEST_SOCIAL_LINK_STATUS_ERROR';
export const CLEAR_REQUEST_SOCIAL_LINK_STATUS = 'LINKS/CLEAR_REQUEST_SOCIAL_LINK_STATUS';

// MOBILE APPS LINKS
export const FETCH_MOBILE_APPS_LINKS_LIST = 'LINKS/FETCH_MOBILE_APPS_LINKS_LIST';
export const FETCH_MOBILE_APPS_LINKS_LIST_ERROR = 'LINKS/FETCH_MOBILE_APPS_LINKS_LIST_ERROR';
export const CLEAR_FETCH_MOBILE_APPS_LINKS_LIST = 'LINKS/CLEAR_FETCH_MOBILE_APPS_LINKS_LIST';

export const ADD_MOBILE_APPS_LINK_SUCCESS = 'LINKS/ADD_MOBILE_APPS_LINK_SUCCESS';
export const ADD_MOBILE_APPS_LINK_ERROR = 'LINKS/ADD_MOBILE_APPS_LINK_ERROR';
export const CLEAR_ADD_MOBILE_APPS_LINK = 'LINKS/CLEAR_ADD_MOBILE_APPS_LINK';

export const PATCH_MOBILE_APPS_LINK_SUCCESS = 'LINKS/PATCH_MOBILE_APPS_LINK_SUCCESS';
export const PATCH_MOBILE_APPS_LINK_ERROR = 'LINKS/PATCH_MOBILE_APPS_LINK_ERROR';
export const CLEAR_PATCH_MOBILE_APPS_LINK = 'LINKS/CLEAR_PATCH_MOBILE_APPS_LINK';

export const DELETE_MOBILE_APPS_LINK_SUCCESS = 'LINKS/DELETE_MOBILE_APPS_LINK_SUCCESS';
export const DELETE_MOBILE_APPS_LINK_ERROR = 'LINKS/DELETE_MOBILE_APPS_LINK_ERROR';
export const CLEAR_DELETE_MOBILE_APPS_LINK = 'LINKS/CLEAR_DELETE_MOBILE_APPS_LINK';

export const APPLY_MOBILE_APPS_LINK_DRAG_SUCCESS = 'LINKS/APPLY_MOBILE_APPS_LINK_DRAG_SUCCESS';
export const APPLY_MOBILE_APPS_LINK_DRAG_ERROR = 'LINKS/APPLY_MOBILE_APPS_LINK_DRAG_ERROR';
export const CLEAR_MOBILE_APPS_LINK_DRAG = 'LINKS/CLEAR_MOBILE_APPS_LINK_DRAG';
